(function($) {
	
	var $definitions = $('.definitions');
	var $window = $(window);
	var breakpoint = 992;

	if ( $definitions.length ) {

		$window.resize(function(event) {
			var width = $window.width();
			console.log( width );
			if ( width > breakpoint ) {

				$definitions.each(function(index, el) {
					var $prevElem = $(el).prev();
					var prevElemRight = $prevElem.offset().left + $prevElem.width() + 20;
					var prevElemTop = $prevElem.offset().top;
					
					$(el).css('position', 'absolute');
					$(el).css('top', prevElemTop );
					$(el).css('left', prevElemRight );
					$(el).css('width', '18rem' );
				});

			} else {
				$definitions.each(function(index, el) {
					$(el).css('position', '');
					$(el).css('top', '' );
					$(el).css('left', '' );
					$(el).css('width', '' );
				});
			}

		}).trigger('resize');

		$('#post-content figure').each(function(){
			$(this).addClass('img-def');
		});

	}

})(jQuery);